import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p_nation"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "nav_left" }, null, -1);
const _hoisted_3 = { class: "nav_center" };
const _hoisted_4 = {
    key: 0,
    class: "pc"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1);
const _hoisted_6 = { key: 1 };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1);
const _hoisted_8 = { key: 0 };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1);
const _hoisted_10 = {
    key: 1,
    class: "pc"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1);
const _hoisted_12 = { class: "nav_right" };
import { computed } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuestionPagination',
    props: {
        questions: null
    },
    setup(__props) {
        const props = __props;
        const getPageParams = (activePage, totalPagesCount, showPagesCount, showOnEachSide) => {
            let start;
            let end;
            if (totalPagesCount >= showPagesCount && activePage <= showPagesCount - showOnEachSide) {
                start = 1;
                end = showPagesCount;
            }
            else if (totalPagesCount >= showPagesCount && activePage >= totalPagesCount - showOnEachSide) {
                start = totalPagesCount - (showPagesCount - 1);
                end = totalPagesCount;
            }
            else {
                start = activePage - showOnEachSide;
                end = activePage + showOnEachSide;
            }
            return [start, end];
        };
        const pages = computed(() => {
            let start;
            let end;
            const showOnEachSide = 2;
            const showPagesCount = 5;
            let totalPagesCount = props.questions.meta.last_page;
            const pattern = /^[0-9]+$/;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const activePage = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1;
            [start, end] = getPageParams(activePage, totalPagesCount, showPagesCount, showOnEachSide);
            return props.questions.meta.links.filter(value => pattern.test(value.label) &&
                parseInt(value.label) >= start &&
                parseInt(value.label) <= end);
        });
        return (_ctx, _cache) => {
            return (props.questions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("ul", null, [
                            (props.questions.links.prev)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                    _createVNode(_unref(Link), {
                                        href: props.questions.links.first
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_5
                                        ]),
                                        _: 1
                                    }, 8, ["href"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.questions.links.prev)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                    _createVNode(_unref(Link), {
                                        href: props.questions.links.prev
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_7
                                        ]),
                                        _: 1
                                    }, 8, ["href"])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (page) => {
                                var _a;
                                return (_openBlock(), _createElementBlock("li", null, [
                                    _createVNode(_unref(Link), {
                                        href: (_a = page.url) !== null && _a !== void 0 ? _a : '',
                                        class: _normalizeClass({ active: page.active })
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(page.label), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["href", "class"])
                                ]));
                            }), 256))
                        ]),
                        _createElementVNode("ul", null, [
                            (props.questions.links.next)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                                    _createVNode(_unref(Link), {
                                        href: props.questions.links.next
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_9
                                        ]),
                                        _: 1
                                    }, 8, ["href"])
                                ]))
                                : _createCommentVNode("", true),
                            (props.questions.links.next)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                    _createVNode(_unref(Link), {
                                        href: props.questions.links.last
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_11
                                        ]),
                                        _: 1
                                    }, 8, ["href"])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(props.questions.meta.total.toLocaleString()), 1),
                        _createTextVNode("件 ")
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
